export default "__VITE_ASSET__18176cd3__"